import React from "react";

import { Icon, WrappingIconProps } from "../Icon";

export const PausedIcon = (props: WrappingIconProps) => {
  return (
    <Icon {...props} fill="none">
      <path
        d="M19 12.5C19 16.6421 15.6421 20 11.5 20C7.35786 20 4 16.6421 4 12.5C4 8.35786 7.35786 5 11.5 5"
        stroke="currentcolor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M12 9V11.5882L14 13"
        stroke="currentcolor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <line
        x1="15.5"
        y1="5"
        x2="15.5"
        y2="8"
        stroke="currentcolor"
        strokeWidth="2"
        strokeLinecap="round"
      />
      <line
        x1="19"
        y1="5"
        x2="19"
        y2="8"
        stroke="currentcolor"
        strokeWidth="2"
        strokeLinecap="round"
      />
    </Icon>
  );
};
